import { GrantsType } from '../types';
import { ReactElement } from 'react';

type CanProps<T> = {
  yes?: () => ReactElement | null;
  no?: () => ReactElement | null;
  grants: GrantsType;
  context?: T;
  policy: (grants: GrantsType, context?: T) => boolean;
};

export function Can<T>({
  yes = () => null,
  no = () => null,
  grants,
  context,
  policy,
}: CanProps<T>) {
  return policy(grants, context) ? yes() : no();
}
